import { useRef, useState } from 'react'

import styled from 'styled-components'

import { DropdownButton } from 'components-ref/molecules/dropdown/DropdownButton/DropdownButton'
import { DropdownContent } from 'components-ref/molecules/dropdown/DropdownContent/DropdownContent'
import { useOutsideAlerter } from 'helpers/hooks'

export function DropdownNavigation() {
    const dropdownRef = useRef<HTMLDivElement>(null)
    const [isOpen, setIsOpen] = useState(false)
    function handleOpen() {
        setIsOpen(true)
    }
    function handleClose() {
        setIsOpen(false)
    }
    function toggleOpen() {
        isOpen ? handleClose() : handleOpen()
    }
    useOutsideAlerter(dropdownRef, () => {
        handleClose()
    })
    return (
        <Container ref={dropdownRef}>
            <DropdownButton toggleOpen={toggleOpen} />
            <DropdownContent
                open={isOpen}
                handleClose={handleClose}
            ></DropdownContent>
        </Container>
    )
}
const Container = styled.div`
    position: relative;
`
